import React from 'react'

export const Actions = ({
  className = '',
  children,
}: {
  className?: string
  children: React.ReactNode
}) => (
  <div
    role='row'
    className={`row no-gutters d-flex justify-content-between ${className}`}
  >
    {/* keep this empty cell to maintain the 4 columns structure */}
    <div role='cell' className='col-12' aria-hidden />

    {children}
  </div>
)
